<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null">
  <mat-label>
    @if (teamStatusIcon) {
      <span class="teams-status-icon" [ngClass]="teamStatusIcon" role="img"></span>
    }
    {{ label }}
  </mat-label>
  <nimbus-mat-duration-picker
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [timeFormat]="format"
    [disabled]="isDisabled"
    [errorStateMatcher]="this"
  >
  </nimbus-mat-duration-picker>
  <ng-container matSuffix>
    <ng-content></ng-content>
  </ng-container>
  @if (!isDisabled && value && removable) {
    <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CLOSE_LIGHT" (click)="onClearValueClick($event)"></i>
  }
  @if (isDisabled) {
    <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
  }
  @if (!isDisabled) {
    <i matSuffix [nimbusIcon]="icons.CLOCK_LIGHT" class="cursor-pointer"></i>
  }
  @if (ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid) {
    <mat-error>
      <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }
  <mat-hint align="end" class="time-format">{{ format.toUpperCase() }}</mat-hint>
</mat-form-field>
